import React from 'react';

interface FooterProps {
  onNavigate: (page: string) => void;
}

const Footer: React.FC<FooterProps> = ({ onNavigate }) => {
  const footerLinks = [
    { label: 'Home', page: 'home' },
    { label: 'Articles', page: 'articles' },
    { label: 'On-Chain', page: 'onchain' },
    { label: 'Newsletter', page: 'newsletter' },
    { label: 'About', page: 'about' },
    { label: 'Contact', page: 'contact' },
    { label: 'Privacy Policy', page: 'privacy' },
  ];

  return (
    <footer className="bg-[#080808] border-t border-white/5 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-8">
          {/* Logo + tagline */}
          <div className="max-w-xs">
            <button onClick={() => onNavigate('home')} className="flex items-center gap-2 mb-3 hover:opacity-90 transition-opacity">
              <div className="w-8 h-8 rounded-full bg-[#F7931A] flex items-center justify-center">
                <span className="text-black font-black text-sm">₿</span>
              </div>
              <div className="flex items-baseline gap-1">
                <span className="font-bold text-white text-lg tracking-tight">UTXO</span>
                <span className="font-semibold text-[#F7931A] text-xs tracking-widest uppercase">MACRO</span>
              </div>
            </button>
            <p className="text-gray-600 text-sm leading-relaxed">
              Bitcoin, Macro, and AI. Facts and some opinions.
            </p>
          </div>

          {/* Nav links */}
          <div>
            <p className="text-gray-500 text-xs font-semibold uppercase tracking-widest mb-3">Navigate</p>
            <div className="flex flex-col gap-2">
              {footerLinks.map((link) => (
                <button
                  key={link.page}
                  onClick={() => onNavigate(link.page)}
                  className="text-gray-400 text-sm hover:text-white transition-colors text-left"
                >
                  {link.label}
                </button>
              ))}
            </div>
          </div>

          {/* Social */}
          <div>
            <p className="text-gray-500 text-xs font-semibold uppercase tracking-widest mb-3">Follow</p>
            <div className="flex flex-col gap-2">
              <a
                href="https://x.com/UTXOMacro"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 text-sm hover:text-white transition-colors flex items-center gap-2"
              >
                <span className="font-bold text-gray-500">𝕏</span>
                @UTXOMacro
              </a>
              <a
                href="https://github.com/UTXOMacro"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 text-sm hover:text-white transition-colors"
              >
                GitHub
              </a>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-10 pt-6 border-t border-white/5 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <p className="text-gray-700 text-xs">
            © 2026 UTXOMacro. All rights reserved.
          </p>
          <p className="text-gray-800 text-xs">
            Not financial advice. Do your own research.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
